export function isUrl(testUrl) {
    return /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/gi.test(testUrl);
}
export function isEmptyString(str) {
    return str.trim() === "";
}
export function isLengthInvalid(str, maxLength) {
    return str.length > maxLength;
}
